import { HeaderLG } from "../design-system/typography";
import { ReactNode } from "react";
import { cn } from "@verse_core/shared_components/ClassName";

/** Rebranded auth page: the background image and a card with the Verse
 * lockup on top. `wide` gives multi-field flows like sign-up a solid,
 * 720px card; `className` can override the card's spacing. */
export const AuthCardLayout = ({
  wide = false,
  className,
  children,
}: {
  wide?: boolean;
  className?: string;
  children: ReactNode;
}) => (
  <div
    className="tw-flex tw-min-h-screen tw-w-full tw-items-center tw-justify-center tw-bg-verse-surface-secondary tw-bg-cover tw-bg-center tw-bg-no-repeat tw-p-[24px]"
    style={{ backgroundImage: "url('/login/login-background.webp')" }}
  >
    <div
      className={cn(
        "tw-flex tw-w-full tw-flex-col tw-items-center tw-gap-[40px] tw-rounded-[8px] tw-p-[48px] 540:tw-p-[24px]",
        wide
          ? "tw-max-w-[720px] tw-bg-white"
          : "tw-max-w-[440px] tw-bg-white/80",
        className,
      )}
    >
      <img
        src="/login/verse-lockup.svg"
        alt="Verse"
        className="tw-h-[28px] tw-w-[120px]"
      />
      {children}
    </div>
  </div>
);

/** Rebranded auth card with a heading over the card content. */
export const LoginCard = ({
  heading,
  children,
}: {
  heading: string;
  children: ReactNode;
}) => (
  <AuthCardLayout>
    <div className="tw-flex tw-w-full tw-flex-col tw-gap-[24px]">
      <HeaderLG>{heading}</HeaderLG>
      {children}
    </div>
  </AuthCardLayout>
);

export const LOGIN_CARD_BODY_CLASS =
  "tw-m-0 tw-font-sohne tw-text-[14px] tw-text-verse-text-tertiary";
